import React from 'react';
import { useLocationHref } from '../Router';
import RedirectExternal from './RedirectExternal';
import { jsx as _jsx } from "react/jsx-runtime";
export const useLoginUrl = () => {
  const currentUrl = useLocationHref();
  return "/login?redirect=".concat(encodeURIComponent(currentUrl));
};
const RedirectToLogin = () => {
  const loginUrl = useLoginUrl();
  return /*#__PURE__*/_jsx(RedirectExternal, {
    url: loginUrl,
    statusCode: 302
  });
};
export default RedirectToLogin;